import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { DownloadLogsProgressResData } from "./DownloadLogsProgressResData";

const ENDPOINT = "/download_logs/progress";

export class GetDownloadOnDemandProgressCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: any;

    constructor(installationName: string) {
        super();
        this.params = { installationName: installationName };
    }

    public async execute(): Promise<DownloadLogsProgressResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new DownloadLogsProgressResData(res);
    }
}
